import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import * as appConstants from "../../../constants/index";
import { ProceedButton } from "../../common/login/loginTags";

const AmazonPay = (props) => {
  const formRef = useRef(null);
  const bookingid = localStorage.getItem("bookingid");
  const theme = localStorage.getItem("theme");
  const [loading, setLoading] = useState(false);
  const paymentOptions = parseInt(localStorage.getItem("paymentOptions") || 0);
  const gaTagData = JSON.parse(localStorage.getItem("gaTagData"));

  const ticketSummary = JSON.parse(localStorage.getItem('ticket_summary_alldata'));

  function getJourneyValue(dataitem) {
    if (dataitem?.familyBundle_data?.voucherDesc) return "buy_family_offer";
    if (dataitem?.cvp_data) return "buy_cvp";
    if (dataitem?.superTicketData) return "buy_super_ticket";
    if (dataitem?.flexiTotalTicketPrice > 0) return "buy_flexi_ticket";
    return "";
  }

  let journeyvalue = "";
  if (localStorage.getItem("booking_type") === "BOOKING" && ticketSummary?.orderFood?.foodType && ticketSummary?.orderFood.foodType !== "") {
    journeyvalue = "Movie_Food";
  } else if (localStorage.getItem("booking_type") === "BOOKING") {
    journeyvalue = "Movie";
  } else if (localStorage.getItem("bookingid")) {
    journeyvalue = "Add_Food";
  } else if (localStorage.getItem("booking_type") === "FOOD") {
    journeyvalue = "Only_Food";
  } else {
    journeyvalue = "";
  }

  const hitBeginCheckout = (
    event,
    currency,
    value,
    journey_type,
    discount,
    discount_type,
    movie_item_brand,
    movie_item_name,
    movie_item_id,
    movie_item_list_name,
    movie_item_list_id,
    movie_item_category,
    movie_item_category2,
    movie_item_category3,
    movie_item_category4,
    movie_item_category5,
    movie_price,
    movie_quantity,
    movie_item_variant,
    movie_location_id,
    food_item_brand,
    food_item_name_str,
    food_item_id_str,
    food_item_category,
    food_item_category2,
    food_item_category3,
    food_item_category4,
    food_item_category5,
    food_price_arr,
    food_quantity_arr,
    food_location_id,
    affiliation = "AMAZON"
  ) => {
    const dataLayer = window.dataLayer || [];
    const items = [];

    // Normalize journey_type to lowercase for comparison
    const type = journey_type?.toLowerCase() || "";

    // ✅ Add movie details if journey_type includes movie (Movie_Food or Only_Movie)
    if (type.includes("movie")) {
      items.push({
        item_brand: movie_item_brand,
        item_name: movie_item_name,
        item_id: movie_item_id,
        item_list_name: movie_item_list_name,
        item_list_id: movie_item_list_id,
        item_category: movie_item_category,
        item_category2: movie_item_category2,
        item_category3: movie_item_category3,
        item_category4: movie_item_category4,
        item_category5: movie_item_category5,
        price: Number(movie_price) || 0,
        quantity: Number(movie_quantity) || 1,
        coupon: localStorage.getItem("vouId") || "",
        item_variant: movie_item_variant,
        location_id: movie_location_id
      });
    }

    // ✅ Add food details if journey_type includes food (Movie_Food or Only_Food)
    if (type.includes("food")) {
      const food_names =
        typeof food_item_name_str === "string" ? food_item_name_str.split(",") : [];
      const food_ids =
        typeof food_item_id_str === "string" ? food_item_id_str.split(",") : [];

      for (let i = 0; i < food_names.length; i++) {
        items.push({
          item_brand: food_item_brand,
          item_name: food_names[i],
          item_id: food_ids[i],
          item_category: food_item_category,
          item_category2: food_item_category2,
          item_category3: food_item_category3,
          item_category4: food_item_category4,
          item_category5: food_item_category5,
          price: Array.isArray(food_price_arr)
            ? Number(food_price_arr[i])
            : Number(food_price_arr),
          quantity: Array.isArray(food_quantity_arr)
            ? Number(food_quantity_arr[i])
            : Number(food_quantity_arr) || 1,
          coupon: localStorage.getItem("vouId") || "",       
          location_id: food_location_id
        });
      }
    }

    // ✅ Push to GTM dataLayer
    dataLayer.push({
      event,
      ecommerce: {
        currency,
        value,
        affiliation,
        journey_type,
        discount,
        discount_type,
        items
      }
    });
  };


  useEffect(() => {
    //getNetBankingList1();
    console.log(props);
    initJuspay();
  }, []);

  const initJuspay = async () => {
    var juspay_form = Juspay.Setup({
      payment_form: "#payment_form_wallet",
      success_handler: function (status) {
        console.log(status);
      },
      error_handler: function (error_code, error_message, bank_error_code, bank_error_message, gateway_id) {
        console.log('error', error_code, error_message);
      },
      customer: {

        customer_id: props.juspayinit ? props.juspayinit.customer_id : '',// change to relevant customer id value

        client_auth_token: props.juspayinit ? props.juspayinit.client_auth_token : '',// populate the active client_auth_token value fetched from Create Order/Create Customer API

      },
    })
  }
  const gethmac = async () => {
    // if(!value6){
    //   setErrorMsg("Please enter vpa!");
    //   setShowAlert(true);
    //   return '';
    // }
    setLoading(true);
    const postData = {
      "transId": localStorage.getItem("transid"),
      "bookingId": localStorage.getItem("bookingid"),
      "bookType": localStorage.getItem("booking_type") === "GIFTCARD" ? 'GIFTCARD' : localStorage.getItem("booking_type") === "FOOD" ? 'FOOD' : 'BOOKING',
      "paytype": "WALLET",
      "pgtype": "JUSPAY"
    };
    const vouDesc = localStorage.getItem("vouDesc") || "";
    const vouId = localStorage.getItem("vouId") || "";
    const discValue = localStorage.getItem("discValue") || "";
    const validity = localStorage.getItem("validity") || "";
    const itemCategory5 = `${vouDesc}, ${vouId}, ${discValue}, ${validity}`;

    await axios
      .post(`${appConstants.base_url}v1/payment/juspay/hmac`, postData, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token") || ""
            }`,
          chain: theme === "inoxTheme" ? "INOX" : "PVR",
          city: localStorage.getItem("city"),
          appVersion: appConstants.av,
          platform: appConstants.pt,
          country: appConstants.cname,
        },
      })
      .then((res) => {
        const dt = res.data;
        if (dt.result === "success") {
          localStorage.setItem('pgused', 'AMAZON');
          const url = window.location.href;

          localStorage.setItem("cinema_name", url.split('/').pop().replaceAll('%20', ' '));
          window.dataLayer = window.dataLayer || [];
          paymentOptions === 1
            ?
            window.dataLayer.push({
              event: 'add_payment_info',
              ecommerce: {
                currency: 'INR',
                value: Number(res.data.output.amount),
                affiliation: 'AMAZON',
                items: [{
                  item_brand: appConstants.cinemaChain,
                  item_name: gaTagData?.movieName || false,
                  item_id: gaTagData?.movieId || false,
                  item_category: localStorage.getItem("booking_type") || "FOOD",
                  item_category2: gaTagData?.theaterName || false,
                  item_category3: gaTagData?.selectedDate ? `${gaTagData?.selectedDate} / ${gaTagData?.selectedSeats || ""}` : format(new Date(), "yyyy-MM-dd hh:mm a"),
                  item_category4: gaTagData?.genre && gaTagData?.languages ? `${gaTagData?.genre} / ${gaTagData?.languages}` : false,
                  item_category5: false,
                  item_variant: gaTagData?.variant || false,
                  quantity: gaTagData?.qty || false,
                  price: Number(res.data.output.amount),
                }]
              }
            })
            :
            // window.dataLayer.push({
            //   event: 'add_payment_info',
            //   ecommerce: {
            //     currency: 'INR',
            //     value: res.data.output.amount,
            //     affiliation: 'AMAZON',                   //(payment type)                                                
            //     items: [{
            //       item_brand: appConstants.cinemaChain,                       // (pvr/inox)
            //       item_name: localStorage.getItem('movie_name'),                            // (ticket's name,passport's name,gift card's name)
            //       item_id: localStorage.getItem('movieid'),                             //(ticket's id,passport's id,gift card's id)
            //       //(total amount)
            //       //(total amount)
            //       item_category: 'ticket' + "," + vouDesc,                        //(selected ticket, gift card & passport)
            //       item_category2: localStorage.getItem('city') + "/" + localStorage.getItem('cinema_name'),
            //       item_category3: localStorage.getItem('selecteddate') + "," + localStorage.getItem('selectedseats'),                         //( selected date & seat number)
            //       item_category4: localStorage.getItem('genre'),
            //       item_category5: itemCategory5,                 //(language &  genre)
            //       item_variant: localStorage.getItem('format'),                      //( selected format)   
            //       quantity: localStorage.getItem('quantity'),
            //       price: res.data.output.amount,


            //     }]
            //   }
            // });
            // setTicketSummary(ndt);
            //document.getElementById("payment_form_NB").submit();
            hitBeginCheckout(
              "add_payment_info",
              "INR",
              Number(ticketSummary.totalAmount.replace(/,/g, "")),
              journeyvalue,
              appConstants.cinemaChain,
              localStorage.getItem("filimname") || localStorage.getItem("movie_name"),
              localStorage.getItem("movieid"),
              ticketSummary?.orderFilmCinema?.filmName,
              ticketSummary?.orderFilmCinema?.filmId,
              "Movie",
              localStorage.getItem("gatagbookingtype"),
              getJourneyValue(ticketSummary),
               ticketSummary?.orderFilmCinema?.theaterName || localStorage.getItem("cinema_name"),
              `${ticketSummary?.orderFilmCinema?.language} / ${ticketSummary?.orderFilmCinema?.genre} /  ${ticketSummary?.showTimeStr} /${ticketSummary.orderTicket.seats}`,
              Number(localStorage.getItem("seatPrice")),
              ticketSummary.orderTicket.numOfSeats,
              localStorage.getItem("format") +  "|" + ticketSummary?.orderFilmCinema?.format,
              localStorage.getItem("city"),
              appConstants.cinemaChain,
              ticketSummary?.orderFood?.foods.map(item => item.name).join(","),
              ticketSummary?.orderFood?.foods.map(item => item.itemId).join(","),
              "Food",
              localStorage.getItem("gatagbookingtype"),
              //getJourneyValue(ticketSummary),
              itemCategory5 || getJourneyValue(ticketSummary),
              ticketSummary?.orderFilmCinema?.theaterName || localStorage.getItem("cinema_name"),
              `${ticketSummary?.orderFilmCinema?.language} / ${ticketSummary?.orderFilmCinema?.genre} /  ${ticketSummary?.showTimeStr} /${ticketSummary.orderTicket.seats}`,
              ticketSummary?.orderFood?.foods.map(item => item.price / 100 || 0),
              ticketSummary?.orderFood?.foods.map(item => item.quantity || 0),
              localStorage.getItem("city"),
              "AMAZON"
            );


          localStorage.setItem("paymentid", dt.output.paymentId);
          localStorage.setItem("payment_type", "nonwallet");
          console.log("bankList==>", dt);
          formRef.current.click();
        } else {
          setLoading(false);
          console.log(res.data.msg);
        }
      })
      .catch((err) => {
        console.log("error", err);
        setLoading(false);
      });
  }
  return (
    <>
      <div className="">
        <div className="payment-form">
          <div className="paywithdebit ">
            <div className="debit-card show-in-desktop-view">
              <h6>{props?.payMode?.name}</h6>
            </div>
            <div className="to-paid">
              {/* <p>
              To be Paid:
              <span className="price-cross">₹8888</span>{" "}
              <span className="price-blod">₹8888</span>
            </p> */}
            </div>
          </div>
          <div className="cinema-house payment-postpaytm">
            {/* <h1>Enter OTP</h1>
          <p className="otp-content">You need to enter the OTP received</p>
          <h6>+91 {sendOTPFormik.values.mobileInput}</h6>
          <div className="otp-feild">
            <OtpInput
              value={mobileOtp}
              onChange={setMobileOtp}
              numInputs={6}
              inputStyle={{width:'60px'}}
              // renderSeparator={<span>-</span>}
              renderInput={(props) => <input {...props} className="otpfeild" />}
            />
          </div> */}
            <div className="register-btn">
              <ProceedButton className={!loading ? "btn-proceeds verfiy-paytm" : "btn-proceeds verfiy-paytm btn-opacity"} onClick={() => gethmac()}>
                Continue Pay {props?.payMode?.name}
                {loading ? (
                  <i
                    className="pi pi-spin pi-spinner"
                    style={{ fontSize: "1.5em" }}
                  ></i>
                ) : (
                  ""
                )}
              </ProceedButton>
            </div>
            {/* <div className="resend-otp">
            <h6
              style={{ cursor: "pointer" }}
              // onClick={() => reSendOTPService()}
            >
              Resend OTP
            </h6>
          </div> */}
            <div className="row pt-4">
              <div className="col-md-12">
                <div className="gyftr-box">
                  <p>Clicking would redirect you to AmazonPay’s payment page.</p>
                  {/* <div className="divider-gyftr"></div>
                  <p>*If there is an intent connectivity problem while booking the free tickets using your coupon codes and the tickets are not issued please wait for 30 minutes before trying to use the Coupon Codes again.</p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <form className="juspay_inline_form" id="payment_form_wallet" style={{ "display": "none" }}>
          <input type="hidden" className="merchant_id" value={props.juspayinit ? props.juspayinit.merchant_id : ''} />
          <input type="hidden" className="order_id" value={bookingid} />
          <input type="hidden" className="payment_method_type" value="WALLET" />
          <div className="">
            <div className="modal-tab-block">
              <div className="modal-tab-block">
                <div className="form-group">
                  <div className="select-box">
                    <select className="payment_method" id="walletselect">
                      <option value="AMAZONPAY" label="AMAZONPAY" selected>AMAZONPAY</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button ref={formRef} type="submit" className="make_payment">
            Pay
          </button>
          <input type="hidden" className="redirect" value="true" />
          <input type="hidden" className="payment_channel" value="WEB" />
          <input type="hidden" id="direct_wallet_token" className="direct_wallet_token" value="" />
        </form>
      </div>
    </>
  )
}

export default AmazonPay